import { Metadata_NumberCategory$reflection, Metadata_NumberCategory, Metadata_StringCategory$reflection, Metadata_StringCategory } from "../../../../Shared/Shared.js";
import { class_type } from "../../../../fable_modules/fable-library.3.7.9/Reflection.js";

export class Tid extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "tid";
    }
}

export function Tid$reflection() {
    return class_type("Corpora.Taus3.MetadataCategories.Tid", void 0, Tid, Metadata_StringCategory$reflection());
}

export function Tid_$ctor_Z721C83C5(aName) {
    return new Tid(aName);
}

export class Sex extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "sex";
    }
}

export function Sex$reflection() {
    return class_type("Corpora.Taus3.MetadataCategories.Sex", void 0, Sex, Metadata_StringCategory$reflection());
}

export function Sex_$ctor_Z721C83C5(aName) {
    return new Sex(aName);
}

export class Age extends Metadata_NumberCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "age";
    }
}

export function Age$reflection() {
    return class_type("Corpora.Taus3.MetadataCategories.Age", void 0, Age, Metadata_NumberCategory$reflection());
}

export function Age_$ctor_Z721C83C5(aName) {
    return new Age(aName);
}

export class Abode extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "abode";
    }
}

export function Abode$reflection() {
    return class_type("Corpora.Taus3.MetadataCategories.Abode", void 0, Abode, Metadata_StringCategory$reflection());
}

export function Abode_$ctor_Z721C83C5(aName) {
    return new Abode(aName);
}

export class Edu extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "edu";
    }
}

export function Edu$reflection() {
    return class_type("Corpora.Taus3.MetadataCategories.Edu", void 0, Edu, Metadata_StringCategory$reflection());
}

export function Edu_$ctor_Z721C83C5(aName) {
    return new Edu(aName);
}

export class Pro extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "pro";
    }
}

export function Pro$reflection() {
    return class_type("Corpora.Taus3.MetadataCategories.Pro", void 0, Pro, Metadata_StringCategory$reflection());
}

export function Pro_$ctor_Z721C83C5(aName) {
    return new Pro(aName);
}

